/**
 * What the portal says about E16a's static check of a generation (api/lib/generated_check.py).
 * Only a finding earns a line: a result with nothing to report shows nothing, and a check that
 * could not be made (`not_checked`) is not a finding about the customer's code. The check never
 * says the tests pass, so none of this text does.
 */

import type { GenerationValidation } from '../api/client';

export interface ValidationNote {
  level: 'info' | 'error';
  text: string;
}

export function validationNotes(validation: GenerationValidation | undefined): ValidationNote[] {
  if (!validation) return [];
  const notes: ValidationNote[] = [];

  if (validation.script === 'syntax_error') {
    notes.push({
      level: 'error',
      text: 'The script is not valid Python, so it will not run as it is. Read it before you use it.',
    });
  }

  switch (validation.tests?.static) {
    case 'rewritten':
      notes.push({
        level: 'info',
        text:
          'The tests imported the script under another module name. We changed that import to ' +
          'etl_job, the name to save the script as; nothing else in the tests was touched.',
      });
      break;
    case 'names_missing':
      notes.push({
        level: 'error',
        text: 'The tests take names the script does not define, so they will fail to import. Read them before you use them.',
      });
      break;
    case 'syntax_error':
      notes.push({
        level: 'error',
        text: 'The tests are not valid Python, so they will not run as they are.',
      });
      break;
    default:
      break;
  }

  return notes;
}
